<template>
    <b-card no-body>
        <b-form>
            <b-tabs card>
                <b-tab title="Informazioni">
                    <info-tab v-model="event" />
                </b-tab>
                <b-tab title="Campi">
                    <fields-tab v-model="form_fields_data" />
                </b-tab>
                <b-tab title="Avanzate">
                    <advanced-tab v-model="event" />
                </b-tab>
                <b-tab title="Media" v-if="eventId">
                    <media-tab v-model="event" />
                </b-tab>
                <b-tab title="Quiz" v-if="eventId">
                    <quiz-tab ref="quizTab" :event-id="eventId"></quiz-tab>
                </b-tab>
            </b-tabs>
        </b-form>
        <b-form-group class="col-12 pl-4">
            <hr />
            <b-button variant="success" @click="save">
                Salva
            </b-button>
        </b-form-group>
    </b-card>
</template>

<script>
import gql from 'graphql-tag'
import InfoTab from "./EditEventComponents/InfoTab";
import AdvancedTab from "./EditEventComponents/AdvancedTab";
import FieldsTab from "./EditEventComponents/FieldsTab";
import MediaTab from "./EditEventComponents/MediaTab";

import EventQuery from '../GraphQL/EventQuery.graphql';
import QuizTab from "./EditEventComponents/QuizTab";

export default {
    name: "EditEvent",
    components: {
        QuizTab,
        FieldsTab,
        AdvancedTab,
        InfoTab,
        MediaTab,
    },
    computed: {
        form_fields_data: {
            get() {
                try {
                    return JSON.parse(this.event.form_fields)
                } catch (e) {
                    return []
                }
            },
            set(value) {
                console.log(value)
                this.$set(this.event, 'form_fields', JSON.stringify(value))
            }
        },
        settings_data: {
            get() {
                try {
                    return JSON.parse(this.event.settings)
                } catch (e) {
                    return {}
                }
            },
            set(value) {
                this.$set(this.event, 'settings', JSON.stringify(value))
            }
        }
    },
    data() {
        return {
            event: {
                id: '',
                title: '',
                type: '',
                domain: '',
                template: '',
                default_fake_author: '',
                live_at: '',
                registration_close_at: '',
                embed_code: '',
                visible: false,
                settings: '{}',
                form_fields: '[]',
                all_media: [],
                admin_public_code: '',
                chat_public_code: '',
                guest_public_code: '',
            }
        }
    },
    apollo: {
        event: {
            query: EventQuery,
            variables() {
                return {
                    id: this.eventId,
                }
            },
            skip() {
                return !this.eventId
            }
        }
    },
    props: {
        eventId: {
            type: Number,
            required: false,
        }
    },
    methods: {
        save() {
            let input = this.event
            delete input.id
            delete input.all_media
            delete input.admin_public_code
            delete input.guest_public_code
            delete input.chat_public_code

            if (input.registration_close_at === '') {
                input.registration_close_at = null;
            }

            if (!this.eventId) {
                this.$apollo.mutate({
                    mutation: gql`mutation ($event: EventUpdate!) {
                        createEvent(event: $event) {
                            id
                        }
                    }`,
                    variables: {
                        event: input
                    }
                }).then((data) => {
                    window.location = route('backoffice.events.edit', { id: data.data.createEvent.id })
                })
                .catch((error) => {
                    console.log(error);
                })
            } else {
                this.$apollo.mutate({
                    mutation: gql`mutation ($id: ID!, $event: EventUpdate!) {
                        updateEvent(id: $id, event: $event) {
                            id
                        }
                    }`,
                    variables: {
                        id: this.eventId,
                        event: this.event
                    }
                }).then(() => {
                    this.$bvToast.toast('Evento salvato', {
                        title: 'Salvataggio',
                        variant: 'success',
                        solid: true,
                    })
                })
                .catch((error) => {
                    console.log(error)
                })

                this.$refs.quizTab.saveQuestions();
            }
        }
    }
}
</script>

<style scoped>

</style>
